// The header search's API call (P5-E06): GET /admin/search?q= — organizations, websites and domains the
// caller may see, a few of each (tenancy-scoped on the server).
import { keepPreviousData, queryOptions } from '@tanstack/react-query';
import { api, unwrap, type Schemas } from '@/api/client';

export type SearchOut = Schemas['SearchOut'];

/** The shortest query the API accepts. */
export const MIN_QUERY = 2;

export const searchQuery = (q: string) =>
  queryOptions({
    queryKey: ['search', q] as const,
    queryFn: () => unwrap(api.GET('/admin/search', { params: { query: { q } } })),
    enabled: q.length >= MIN_QUERY,
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
